import React from 'react'
import './styles.scss'

const HobbiesCard = (props) => {
  return (
    <div className="main-frame-card-hobbies">
      {props.HobbiesData.map((item, index) => (
        <div key={index} className="frame-card-hobbies">
          <div style={{ backgroundColor: item.color }} className="circle-img">
            <img src={item.img} alt="" />
          </div>
          <p>{item.content}</p>
        </div>
      ))}
    </div>
  )
}

export default HobbiesCard
